<template>

  <v-dialog class="dialog"
            v-model="isActive"
            max-width="420">

    <v-card>
      <v-card-title class="headline pb-0">Cream mode</v-card-title>
      <v-card-text>Toggle Cream mode to navigate through the videos you searched within a player. This allows you to select the best videos and export the list in csv format</v-card-text>

      <div class="blue-background">
        <v-card-text>Cream mode will be based on your search that found <b>{{ totalItems }} videos</b></v-card-text>
        <v-card-text v-if="totalItems >= 1500 && totalItems < 5000">Loading all videos may take some time.</v-card-text>
        <v-card-text v-if="totalItems >= 5000 && totalItems < 15000">Loading all videos may take a very long time. You can narrow your search.</v-card-text>
        <v-card-text v-if="totalItems >= 15000" class="alert"><b>Too many videos to load, please narrow your search.</b></v-card-text>
      </div>

      <!-- SORTED BY POPULARITY -->
      <v-card-text class="pb-0"><b>Sorted by popularity</b></v-card-text>
      <v-card-text>Videos are sorted by popularity (combination of likes and views), the first ones are those with most popularity</v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="creamModeChosen('popularity')">Choose</v-btn>
      </v-card-actions>

      <!-- SORTED BY LIKES -->
      <v-card-text class="pb-0"><b>Sorted by likes</b></v-card-text>
      <v-card-text>Videos are sorted by likes, the first ones are those with most likes</v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="creamModeChosen('likes')">Choose</v-btn>
      </v-card-actions>

      <!-- SORTED MATCH BY MATCH -->
      <v-card-text class="pb-0"><b>Sorted match by match</b></v-card-text>
      <v-card-text>Videos are sorted match by match, you can navigate using next/prev match buttons</v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="creamModeChosen('match')">Choose</v-btn>
      </v-card-actions>

      <v-card-actions class="justify-end">
        <v-btn @click="cancel">Cancel</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'CreamModePopup',
  props: ['isActive', 'totalItems'],
  methods: {
    creamModeChosen (mode) {
      this.$emit('creamModeChosen', mode)
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    'isActive' () {
      if (!this.isActive) {
        this.cancel()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .blue-background {
    margin: 0 16px;
    padding: 12px;
    background: rgba(#000099, 0.12);
  }

  .alert {
    color: #c10000;
  }

</style>



// WEBPACK FOOTER //
// src/components/CreamModePopup.vue